import { getEnv } from '@/utils'

export enum CONTENT_TYPE {
  // json
  JSON = 'application/json;charset=UTF-8',
  // form-data qs
  FORM_URLENCODED = 'application/x-www-form-urlencoded;charset=UTF-8',
  // form-data  upload
  FORM_DATA = 'multipart/form-data;charset=UTF-8'
}
export const UPLOAD_DEFAULT_FILENAME = 'file'

export const OK_STATUS = 200
export const EXPIRED_CODE = [401, 403]
export const OK_CODE = 1000

export const NEED_CONFIRM_CODE = 30001
export const WARNING_CODE = 30004
export const PIC_VERIFY_CODE = 30002
export const ERR_PIC_VERIFY = 2101
export const NO_ROLE_CODE = 4001
export const baseURL = getEnv('VITE_BD_API_HOST') as string
export const timeout = +getEnv('VITE_BD_API_TIMEOUT')
